module.exports = __webpack_public_path__ + "icons/original/large/large-b6.29228909139aed0e29c1e0d248fdc8b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-b6.png
// module id = mPGt
// module chunks = app